import {Permissions} from "@/js/Permissions";

const OrionRoutes = [
  {
    path: "/orion",
    name: "orion_index",
    component: () => import("@/views/orion/uds/IndexView.vue"),
    meta: {permissions: [Permissions.ORION_EDIT_RESEARCHER_ACCOUNT_SETTINGS]},
  },
  {
    path: "/orion/records/:id",
    name: "orion_edit",
    component: () => import("@/views/orion/uds/EditView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/delete-log",
    name: "orion_delete_history_index",
    component: () => import("@/views/orion/DeleteHistoryIndex.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/edit-queue",
    name: "orion_editqueue_index",
    component: () => import("@/views/orion/editqueue/IndexView.vue"),
    meta: {permissions: [Permissions.ORION, Permissions.ORION_RESEARCHER]},
  },
  {
    path: "/orion/edit-queue/researcher-summary",
    name: "orion_editqueue_researcher_summary",
    component: () => import("@/views/orion/editqueue/ResearcherSummaryView.vue"),
    meta: {permissions: [Permissions.ORION_EDIT_QUEUE_REVIEW]},
  },
  {
    path: "/orion/edit-queue/error-summary",
    name: "orion_editqueue_error_summary",
    component: () => import("@/views/orion/editqueue/errorSummary/IndexView.vue"),
    meta: {permissions: [Permissions.ORION_EDIT_QUEUE_REVIEW]},
  },
  {
    path: "/orion/edit-queue/:id",
    name: "orion_editqueue_edit",
    component: () => import("@/views/orion/editqueue/SingleEditView.vue"),
    meta: {permissions: [Permissions.ORION, Permissions.ORION_RESEARCHER]},
  },
  {
    path: "/orion/download-error-cases",
    name: "orion-error-cases",
    component: () => import("@/views/orion/editqueue/errorCases/IndexView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/edit-queue/duplicates/:id",
    name: "orion_editqueue_duplicates",
    component: () => import("@/views/orion/editqueue/DuplicatesView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/clients",
    name: "orion_clients_index",
    component: () => import("@/views/orion/clients/IndexView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/clients/create",
    name: "orion_create_client_account",
    component: () => import("@/views/orion/clients/CreateView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/clients/:id",
    name: "orion_clients_edit",
    component: () => import("@/views/orion/clients/EditView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/researchers",
    name: "orion_researchers_index",
    component: () => import("@/views/orion/researchers/IndexView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/researchers/create",
    name: "orion_create_researcher_account",
    component: () => import("@/views/orion/researchers/CreateView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/researchers/documents",
    name: "orion_researchers_documents",
    component: () => import("@/views/orion/researchers/documents/IndexView.vue"),
    meta: {permissions: [Permissions.ORION, Permissions.ORION_ALL_RESEARCHER_DOCUMENTS]},
  },
  {
    path: "/orion/researchers/:id",
    name: "orion_researchers_edit",
    component: () => import("@/views/orion/researchers/EditView.vue"),
    meta: {permissions: [Permissions.ORION, Permissions.ORION_RESEARCHER]},
  },
  {
    path: "/orion/researchers/additional-payments/:id",
    name: "orion_researchers_additional_payments",
    component: () => import("@/views/orion/researchers/additional_payments/IndexView.vue"),
    meta: {permissions: [Permissions.ORION_CREATE_ADDITIONAL_PAYMENTS]},
  },
  {
    path: "/orion/transmittals-queue",
    name: "orion_transmittals_queue",
    component: () => import('@/views/orion/transmittals/TransmittalsQueueView'),
    meta: {permissions: [Permissions.ORION_EDIT_RESEARCHER_ACCOUNT_SETTINGS]},
  },
  {
    path: "/orion/transmittals-history",
    name: "orion_transmittals_history",
    component: () => import('@/views/orion/transmittals/TransmittalsHistoryView.vue'),
    meta: {permissions: [Permissions.ORION_EDIT_RESEARCHER_ACCOUNT_SETTINGS]},
  },
  {
    path: "/orion/housing-court-uploads",
    name: "orion_hcr_uploads_index",
    component: () => import("@/views/orion/uploads/IndexView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/nj-uploads",
    name: "orion_nj_uploads_index",
    component: () => import("@/views/orion/njUploads/IndexView.vue"),
    meta: {permissions: [Permissions.ORION_HCR_UPLOAD_NJ_DISPOSITION]},
  },
  {
    path: "/orion/courts",
    name: "orion_courts_index",
    component: () => import("@/views/orion/courts/IndexView.vue"),
    meta: {permissions: [Permissions.ORION]},// TODO: permissions
  },
  {
    path: "/orion/courts/create",
    name: "orion_courts_create",
    component: () => import("@/views/orion/courts/EditView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/courts/:id",
    name: "orion_courts_edit",
    component: () => import("@/views/orion/courts/EditView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/exports",
    name: "orion_exports_index",
    component: () => import("@/views/orion/exports/IndexView.vue"),
    meta: {permissions: [Permissions.ORION]},
  },
  {
    path: "/orion/exports/hygiene",
    name: "orion_exports_hygiene_index",
    component: () => import("@/views/orion/exports/HygieneIndexView.vue"),
    // orion_ud (not just orion): consistent with generating/downloading hygiene
    // exports, which carry HCR/PII.
    meta: {permissions: [Permissions.ORION_UD]},
  },
]

export default OrionRoutes;
